import React from 'react';
import Lottie from 'react-lottie';
import Box from '@material-ui/core/Box';

import animation from './processing.json';

const Processing: React.FC = () => {
  const defaultOptions = {
    loop: true,
    autoplay: true,
    animationData: animation,
  };
  return (
    <Box display="flex" width={'100%'} justifyContent="center" alignItems="center">
      <Lottie options={defaultOptions} width={'90%'} />
    </Box>
  );
};

export { Processing };
